import beauthBrowser from '@/lib/beauth/beauth.browser';
import authApi from '@/store/api/auth/auth.api';
import { sessionClosed, sessionOpened } from '@/store/auth/auth.slice';
import type { TypeAppDispatch } from '@/store/store';

export const sessionLoad = async (dispatch: TypeAppDispatch): Promise<boolean> => {
    try {
        const user = await dispatch(authApi.endpoints.readMe.initiate(undefined, { forceRefetch: true })).unwrap();
        dispatch(sessionOpened({ user }));
        return true;
    } catch {
        dispatch(sessionClosed());
        return false;
    }
};

export const sessionBootstrap = async (dispatch: TypeAppDispatch): Promise<void> => {
    const outcome = await beauthBrowser.refresh('resume');

    if (outcome.status !== 'ok') {
        dispatch(sessionClosed());
        return;
    }

    await sessionLoad(dispatch);
};

export default sessionBootstrap;
